module.exports = __webpack_public_path__ + "static/media/how4.e04a50df.png";